import { gql } from "apollo-boost";

const queries = {
    LOGIN: gql`
        query Login($ic: String!, $password: String!) {
            login(input: { ic: $ic, password: $password }) {
                userId
                token
                name
                type
            }
        }
    `,
    CHANGE_PASSWORD: gql`
        mutation ChangePassword($password: String!, $currentPassword: String!) {
            changePassword(
                password: $password
                currentPassword: $currentPassword
            ) {
                _id
            }
        }
    `,
    EDIT_USER_PROFILE: gql`
        mutation EditUserProfile(
            $nickname: String
            $name: String
            $phone: String
            $bankDetails: String
        ) {
            editUserProfile(
                input: {
                    name: $name
                    nickname: $nickname
                    phone: $phone
                    bankDetails: $bankDetails
                }
            ) {
                _id
            }
        }
    `,
    EDIT_USER_PORTFOLIO: gql`
    mutation EditUserPortfolio(
        $portfolio: String
        $userId: ID!
    ) {
        editUserPortfolio(
            input: {
                portfolio: $portfolio
                userId: $userId
            }
        ) {
            _id
        }
    }
`,
    CREATE_CHATS: gql`
        mutation CreateChats($chats: [CreateChatbotInput!]!) {
            createChatbot(chats: $chats) {
                _id
            }
        }
    `,
    FETCH_CHATS: gql`
        query FetchChats {
            fetchChats {
                id
                connections {
                    outputs {
                        nodeId
                        portName
                    }
                    inputs {
                        nodeId
                        portName
                    }
                }
                inputData {
                    Button
                    Starter
                }
                type
                width
                x
                y
            }
        }
    `,
    FETCH_ALL_AREAS: gql`
        query FetchAllAreas {
            fetchAllAreas {
                _id
                name
            }
        }
    `,
    FETCH_ALL_STATES: gql`
        query FetchAllStates {
            fetchStates {
                _id
                name
            }
        }
    `,
    FETCH_PERFORMANCE: gql`
        query FetchPerformance(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: String
            $user: String
            $salesDirector: ID
            $projectDirector: ID
            $state: ID
            $dateFrom: String
            $dateTo: String
        ) {
            fetchPerformance(
                filter: {
                    project: $project
                    user: $user
                    salesDirector: $salesDirector
                    projectDirector: $projectDirector
                    state: $state
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            ) {
                data {
                    project
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    bookedCases
                    allCases
                    conversionRate
                    cancellationRate
                    rejectionRate
                    pendingRate
                    allRate
                    totalNetGdv
                    convertNetGdv
                    cancelledNetGdv
                    rejectedNetGdv
                    pendingNetGdv
                    totalGrossGdv
                    convertGrossGdv
                    cancelledGrossGdv
                    rejectedGrossGdv
                    pendingGrossGdv
                }
                totals {
                    project
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    bookedCases
                    allCases
                    conversionRate
                    totalNetGdv
                    convertNetGdv
                    cancelledNetGdv
                    rejectedNetGdv
                    pendingNetGdv
                    totalGrossGdv
                    convertGrossGdv
                    cancelledGrossGdv
                    rejectedGrossGdv
                    pendingGrossGdv
                }
            }
        }
    `,
    FETCH_MONTHLY_PERFORMANCE_AGENT: gql`
        query FetchMonthlyPerformanceAgent(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: String
            $user: String
            $state: ID
            $salesDirector: ID
            $year: String
        ) {
            fetchMonthlyPerformanceAgent(
                filter: {
                    project: $project
                    user: $user
                    state: $state
                    salesDirector: $salesDirector
                    year: $year
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            ) {
                totals {
                    month
                    year
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    allCases
                    conversionRate
                    cancellationRate
                    pendingRate
                    rejectionRate
                    allRate
                    totalNetGdv
                    convertNetGdv
                    rejectedNetGdv
                    pendingNetGdv
                    cancelledNetGdv
                }
                data {
                    month
                    year
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    allCases
                    conversionRate
                    cancellationRate
                    pendingRate
                    rejectionRate
                    allRate
                    totalNetGdv
                    convertNetGdv
                    rejectedNetGdv
                    pendingNetGdv
                    cancelledNetGdv
                }
            }
        }
    `,
    FETCH_MONTHLY_COORDINATOR_REPORT: gql`
        query FetchMonthlyCoordinatorReport(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: String
            $user: String
            $state: ID
            $salesDirector: ID
            $year: String
        ) {
            fetchMonthlyCoordinatorReport(
                filter: {
                    project: $project
                    user: $user
                    state: $state
                    salesDirector: $salesDirector
                    year: $year
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            ) {
                data {
                    month
                    year
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    allCases
                    conversionRate
                    cancellationRate
                    pendingRate
                    rejectionRate
                    allRate
                }
            }
        }
    `,

    FETCH_WEEKLY_PERFORMANCE_AGENT: gql`
        query FetchWeeklyPerformanceAgent(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: String
            $user: String
            $state: ID
            $salesDirector: ID
            $year: String
            $month: String
        ) {
            fetchWeeklyPerformanceAgent(
                filter: {
                    project: $project
                    user: $user
                    state: $state
                    salesDirector: $salesDirector
                    year: $year
                    month: $month
                }
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
            
            ) {
                totals {
                    week
                    month
                    year
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    allCases
                    conversionRate
                    cancellationRate
                    pendingRate
                    rejectionRate
                    allRate
                    totalNetGdv
                    convertNetGdv
                    rejectedNetGdv
                    pendingNetGdv
                    cancelledNetGdv
                }
                data {
                    week
                    month
                    year
                    pendingCases
                    cancelledCases
                    rejectedCases
                    convertedCases
                    allCases
                    conversionRate
                    cancellationRate
                    pendingRate
                    rejectionRate
                    allRate
                    totalNetGdv
                    convertNetGdv
                    rejectedNetGdv
                    pendingNetGdv
                    cancelledNetGdv
                }
            }
        }
    `,

    FETCH_PROJECTS: gql`
        query FetchProjects(
            $limit: Int!
            $page: Int!
            $state: String
            $area: String
            $project: String
            $type: String
        ) {
            fetchProjectsAgent(
                pagination: { limit: $limit, page: $page }
                filters: { state: $state, area: $area, project: $project, type: $type }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    name
                    image
                    picName
                    picPhone
                    directorName
                    directorPhone
                    coordinatorName
                    coordinatorPhone
                    area {
                        _id
                        name
                    }
                    developer
                    status
                    type
                    minBedRoom
                    maxBedRoom
                    minBathRoom
                    maxBathRoom
                    unit
                    minSqft
                    maxSqft
                    completionDate
                    state {
                        name
                    }
                    salesDirector {
                        nickname
                        name
                    }
                    projectDirector {
                        nickname
                        name
                    }
                    attributes {
                        attribute
                        value
                    }
                    saleskit
                    hold
                    info {
                        projectLocation
                        projectUnits
                        projectBlocks
                        projectType
                        projectSalesPackage
                        projectCommPercentage
                        projectTelegram
                        projectGallery {
                            _id
                            url
                            title
                        }
                    }
                }
            }
        }
    `,
    FETCH_PROJECT_INFO: gql`
        query FetchProjectInfo($project: String) {
            fetchProjectsAgent(
                pagination: { limit: 1, page: 1 }
                filters: { project: $project }
            ) {
                data {
                    _id
                    name
                    image
                    coordinatorName
                    developer
                    minSqft
                    maxSqft
                    completionDate
                    sdList {
                        _id
                        startDate
                        endDate
                        user {
                            _id
                            nickname
                            name
                        }
                    }
                    pdList {
                        _id
                        startDate
                        endDate
                        user {
                            _id
                            nickname
                            name
                        }
                    }
                    attributes {
                        attribute
                        value
                    }
                    hold
                    info {
                        projectLocation
                        projectUnits
                        projectBlocks
                        projectType
                        projectSalesPackage
                        projectCommPercentage
                        projectGallery {
                            _id
                            url
                            title
                        }
                    }
                }
            }
        }
    `,
    FETCH_TOP_30: gql`
        query FetchTop30s(
            $dateFrom: String
            $dateTo: String
            $state: String
            $type: String
        ) {
            fetchTop30s(
                filter: {
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    state: $state
                    type: $type
                }
            ) {
                data {
                    _id
                    top30 {
                        member {
                            name
                            nickname
                            image
                        }
                        position
                        commission
                    }
                    date
                    type
                }
            }
        }
    `,
    FETCH_VIDEOS: gql`
        query FetchVideos($limit: Int!, $page: Int!) {
            fetchVideos(pagination: { limit: $limit, page: $page }) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    name
                    url
                }
            }
        }
    `,
    FETCH_BANNERS_AGENT: gql`
        query FetchBannersAgent(
            $state: String
            $type: String
            $isMobile: Boolean
            $agent: ID
        ) {
            fetchBannersAgent(
                filter: { state: $state, type: $type, isMobile: $isMobile, agent: $agent }
            ) {
                _id
                name
                url
                type
            }
        }
    `,
    FETCH_CAMPAIGNS_AGENT: gql`
        query FetchCampaignsAgent {
            fetchCampaignsAgent {
                _id
                name
                url
                type
                enNotesArray
                cnNotesArray
            }
        }
    `,
    FETCH_ANNOUNCEMENTS: gql`
        query FetchAnnouncements($limit: Int!, $page: Int!, $status: String) {
            fetchAnnouncements(
                pagination: { limit: $limit, page: $page }
                filter: { status: $status }
            ) {
                data {
                    _id
                    position
                    title
                    en_content
                    cn_content
                    status
                    createdAt
                }
            }
        }
    `,
    EDIT_COMMISSION_STATUS: gql`
        mutation EditCommissionStatus(
            $memberId: ID!
            $fastComm: Float
            $firstBatchComm: Float
            $secondBatchComm: Float
            $fullClaimComm: Float
            $revisedComm: Float
            $type: String!
            $caseId: ID!
        ) {
            editCommissionStatus(
                input: {
                    caseId: $caseId
                    memberId: $memberId
                    fastComm: $fastComm
                    firstBatchComm: $firstBatchComm
                    secondBatchComm: $secondBatchComm
                    fullClaimComm: $fullClaimComm
                    revisedComm: $revisedComm
                    type: $type
                }
            ) {
                _id
                coordinatorCommStatus {
                    fastComm
                    firstBatchComm
                    secondBatchComm
                    fullClaimComm
                    revisedComm
                    coordinator
                }
                members {
                    _id
                    commission
                    newCommission
                    memberAdvancedComm
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    type
                }
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                ptpCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp2Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                    ptp2ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                ptp1Commissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    amount
                    ptp1ReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
            }
        }
    `,
    EDIT_BULK_COMMISSION_STATUS: gql`
        mutation EditBulkCommissionStatus(
            $memberId: ID
            $fastComm: Float
            $firstBatchComm: Float
            $secondBatchComm: Float
            $fullClaimComm: Float
            $revisedComm: Float
            $type: String!
            $cases: [ID!]!
        ) {
            editBulkCommissionStatus(
                input: {
                    cases: $cases
                    memberId: $memberId
                    fastComm: $fastComm
                    firstBatchComm: $firstBatchComm
                    secondBatchComm: $secondBatchComm
                    fullClaimComm: $fullClaimComm
                    revisedComm: $revisedComm
                    type: $type
                }
            ) {
                _id
            }
        }
    `,
    EDIT_BULK_UPLINE_COMMISSION_STATUS: gql`
        mutation EditBulkUplineCommissionStatus(
            $memberId: ID
            $fastComm: Float
            $firstBatchComm: Float
            $secondBatchComm: Float
            $fullClaimComm: Float
            $revisedComm: Float
            $type: String
            $cases: [ID!]!
        ) {
            editBulkUplineCommissionStatus(
                input: {
                    cases: $cases
                    memberId: $memberId
                    fastComm: $fastComm
                    firstBatchComm: $firstBatchComm
                    secondBatchComm: $secondBatchComm
                    fullClaimComm: $fullClaimComm
                    revisedComm: $revisedComm
                    type: $type
                }
            ) {
                _id
            }
        }
    `,
    FETCH_CASES_SALES_RANKING: gql`
        query FetchCasesSalesRanking(
            $limit: Int!
            $page: Int!
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $rank: ID
            $state: ID
            $status: String
        ) {
            fetchCasesSalesRanking(
                pagination: { limit: $limit, page: $page }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                    rank: $rank
                    sate: $state
                }
            ) {
                pagination {
                    documents
                    page
                    limit
                    totalPages
                }
                data {
                    ranking
                    user
                    commission
                }
            }
        }
    `,
    WHOAMI: gql`
        query Whoami {
            whoami {
                image
                name
                nickname
                ranking {
                    _id
                    name
                }
                ic
                passwordChanged
                phone
                bankDetails
                code
                customRank
                cp58
                newcp58
                cp58List {
                    _id
                    year
                    url
                }
                personalSales
                groupSales
                referral {
                    name
                }
                state {
                    name
                }
                email
                director
                omcDate
                emcDate
                pmcDate
                smcDate
                progression
                lastLoginAt
                portfolio
            }
        }
    `,
    FETCH_USER_PAYMENT_VOUCHERS: gql`
        query FetchUserPaymentVouchers(
            $limit: Int!
            $page: Int!
            $dateFrom: String
            $dateTo: String
            $calculatePoints: String
        ) {
            fetchUserPaymentVouchers(
                pagination: { limit: $limit, page: $page }
                filters: {
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    calculatePoints: $calculatePoints
                }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                data {
                    _id
                    payee {
                        _id
                        name
                        nickname
                        code
                    }
                    date
                    method
                    batch
                    status
                    calculatePoints
                    item {
                        amount
                        address
                    }
                    item2 {
                        amount
                        address
                    }
                    item3 {
                        amount
                        address
                    }
                    item4 {
                        amount
                        address
                    }
                    item5 {
                        amount
                        address
                    }
                    orderNo
                }
                totals {
                    totalPaymentVoucher
                    totalVoucherAmount
                }
            }
        }
    `,
    FETCH_CASES_REPORT: gql`
        query FetchCasesAgent(
            $limit: Int!
            $page: Int!
            $by: String
            $dir: String
            $project: ID
            $date: String
            $dateFrom: String
            $dateTo: String
            $status: String
            $downline: ID
        ) {
            fetchCasesAgent(
                pagination: {
                    limit: $limit
                    page: $page
                    sort: { by: $by, dir: $dir }
                }
                filter: {
                    project: $project
                    date: $date
                    dateFrom: $dateFrom
                    dateTo: $dateTo
                    status: $status
                    downline: $downline
                }
            ) {
                totals {
                    cases
                    spaPrice
                    netPrice
                    totalNetGdv
                    totalCommission
                    totalCommissionPercentage
                    totalLegacyCommissionPercentage
                    totalPrimeLeaderComm
                    totalLeaderComm
                    totalPtpReferralComm
                    totalPtp2ReferralComm
                    totalPtp1ReferralComm
                    totalGroupNetGdv
                }
                pagination {
                    documents
                    totalPages
                    page
                    limit
                    by
                    dir
                }
                data {
                    _id
                    members {
                        _id
                        member {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        incentive
                        newCommission
                        commission
                        incentive
                        type
                        memberAdvancedComm
                        referralAdvancedComm
                        leaderReferralAdvancedComm
                        memberCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        ptpReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                    }
                    image
                    salesKit
                    spaPrice
                    rebate
                    fees
                    cashback
                    netPrice
                    status
                    bookingDate
                    convertDate
                    unitNumber
                    sponsorCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        incentive
                        newCommission
                        newAmount
                        amount
                        referralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        referralAdvancedComm
                    }
                    leaderCommissions {
                        _id
                        user {
                            _id
                            name
                            ranking {
                                _id
                                name
                            }
                        }
                        commission
                        incentive
                        newCommission
                        newAmount
                        amount
                        leaderReferralCommStatus {
                            fastComm
                            firstBatchComm
                            secondBatchComm
                            fullClaimComm
                            revisedComm
                        }
                        leaderReferralAdvancedComm
                    }
                    purchaser {
                        purchaserName
                        purchaserName2
                        purchaserName3
                        purchaserName4
                        purchaserName5
                        purchaserIc
                        purchaserIc2
                        purchaserIc3
                        purchaserIc4
                        purchaserIc5
                        purchaserContact
                        purchaserContact2
                        purchaserContact3
                        purchaserContact4
                        purchaserContact5
                    }
                    createdBy {
                        _id
                        name
                    }
                    project {
                        _id
                        name
                    }
                    worker
                }
            }
        }
    `,
    FETCH_FAST_CASES_REPORT: gql`
    query FetchFastCasesAgent(
        $limit: Int!
        $page: Int!
        $by: String
        $dir: String
        $project: ID
        $date: String
        $dateFrom: String
        $dateTo: String
        $status: String
        $downline: ID
    ) {
        fetchFastCasesAgent(
            pagination: {
                limit: $limit
                page: $page
                sort: { by: $by, dir: $dir }
            }
            filter: {
                project: $project
                date: $date
                dateFrom: $dateFrom
                dateTo: $dateTo
                status: $status
                downline: $downline
            }
        ) {
            totals {
                cases
                spaPrice
                netPrice
                totalNetGdv
                totalCommission
                totalCommissionPercentage
                totalPrimeLeaderComm
                totalLeaderComm
                totalPtpReferralComm
                totalPtp2ReferralComm
                totalPtp1ReferralComm
                totalGroupNetGdv
            }
            pagination {
                documents
                totalPages
                page
                limit
                by
                dir
            }
            data {
                _id
                members {
                    _id
                    member {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    newCommission
                    commission
                    incentive
                    type
                    memberAdvancedComm
                    referralAdvancedComm
                    leaderReferralAdvancedComm
                    memberCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    ptpReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                }
                image
                salesKit
                spaPrice
                rebate
                fees
                cashback
                netPrice
                status
                bookingDate
                convertDate
                unitNumber
                sponsorCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    newCommission
                    newAmount
                    amount
                    referralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    referralAdvancedComm
                }
                leaderCommissions {
                    _id
                    user {
                        _id
                        name
                        ranking {
                            _id
                            name
                        }
                    }
                    commission
                    newCommission
                    newAmount
                    amount
                    leaderReferralCommStatus {
                        fastComm
                        firstBatchComm
                        secondBatchComm
                        fullClaimComm
                        revisedComm
                    }
                    leaderReferralAdvancedComm
                }
                purchaser {
                    purchaserName
                    purchaserName2
                    purchaserName3
                    purchaserName4
                    purchaserName5
                    purchaserIc
                    purchaserIc2
                    purchaserIc3
                    purchaserIc4
                    purchaserIc5
                    purchaserContact
                    purchaserContact2
                    purchaserContact3
                    purchaserContact4
                    purchaserContact5
                }
                createdBy {
                    _id
                    name
                }
                project {
                    _id
                    name
                }
                worker
            }
        }
    }
`,
    FETCH_EVENTS_AGENT: gql`
        query FetchEventsAgent {
            fetchEventsAgent {
                _id
                start
                end
                title
                start_time
                end_time
                location
                image
                label
            }
        }
    `,
    FETCH_DOWNLINES: gql`
        query FetchDownlines(
            $limit: Int!
            $page: Int!
            $name: String
            $referral: String
            $status: String
            $rank: ID!
        ) {
            fetchDownlines(
                filters: {
                    name: $name
                    referral: $referral
                    status: $status
                    rank: $rank
                }
                pagination: { limit: $limit, page: $page }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                totals {
                    personalSalesTotal
                    groupSalesTotal
                }
                uplineFilterList {
                    value
                    label
                    id
                }
                data {
                    _id
                    status
                    name
                    nickname
                    dob
                    personalSales
                    groupSales
                    risk
                    progression
                    ranking {
                        _id
                        name
                    }
                    referral {
                        _id
                        name
                        nickname
                    }
                    secondReferral {
                        _id
                        name
                        nickname
                    }
                }
            }
        }
    `,
    FETCH_RISKY_DOWNLINES: gql`
        query FetchRiskyDownlines(
            $limit: Int!
            $page: Int!
            $name: String
            $referral: String
            $status: String
            $rank: ID!
        ) {
            fetchRiskyDownlines(
                filters: {
                    name: $name
                    referral: $referral
                    status: $status
                    rank: $rank
                }
                pagination: { limit: $limit, page: $page }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                totals {
                    personalSalesTotal
                    groupSalesTotal
                }
                uplineFilterList {
                    value
                    label
                    id
                }
                data {
                    _id
                    status
                    name
                    nickname
                    personalSales
                    groupSales
                    risk
                    noConvert
                    progression
                    ranking {
                        _id
                        name
                    }
                    referral {
                        _id
                        name
                        nickname
                    }
                    secondReferral {
                        _id
                        name
                        nickname
                    }
                }
            }
        }
    `,
    FETCH_NO_CONVERT_DOWNLINES: gql`
        query FetchNoConvertDownlines(
            $limit: Int!
            $page: Int!
            $name: String
            $referral: String
            $status: String
            $rank: ID!
        ) {
            fetchNoConvertDownlines(
                filters: {
                    name: $name
                    referral: $referral
                    status: $status
                    rank: $rank
                }
                pagination: { limit: $limit, page: $page }
            ) {
                pagination {
                    documents
                    totalPages
                    page
                    limit
                }
                totals {
                    personalSalesTotal
                    groupSalesTotal
                }
                uplineFilterList {
                    value
                    label
                    id
                }
                data {
                    _id
                    status
                    name
                    nickname
                    personalSales
                    groupSales
                    risk
                    noConvert
                    progression
                    ranking {
                        _id
                        name
                    }
                    referral {
                        _id
                        name
                        nickname
                    }
                    secondReferral {
                        _id
                        name
                        nickname
                    }
                }
            }
        }
    `,
    FETCH_DOWNLINE_SALES_REPORT_AGENT: gql`
        query FetchDownlineSalesReportAgent(
            $dateTo: String
            $dateFrom: String
            $month: String
            $year: String
        ) {
            fetchDownlineSalesReportAgent(
                filter: {
                    dateTo: $dateTo
                    dateFrom: $dateFrom
                    month: $month
                    year: $year
                }
            ) {
                data {
                    user
                    personalBookingSales
                    convertUnit
                    convertPercentage
                    personalNetGdv
                    convertNetGdv
                    netGdvPercentage
                    groupBookingSales
                    groupConvertUnit
                    groupConvertPercentage
                    groupPersonalNetGdv
                    groupConvertNetGdv
                    groupNetGdvPercentage
                    salesRankingCommission
                }
            }
        }
    `,
    FETCH_MANUAL_DOWNLINE_SALES_REPORT_AGENT: gql`
        query FetchManualDownlineSalesReportAgent(
            $dateTo: String
            $dateFrom: String
        ) {
            fetchManualDownlineSalesReportAgent(
                filter: { dateTo: $dateTo, dateFrom: $dateFrom }
            ) {
                data {
                    user
                    personalBookingSales
                    convertUnit
                    convertPercentage
                    personalNetGdv
                    convertNetGdv
                    netGdvPercentage
                    groupBookingSales
                    groupConvertUnit
                    groupConvertPercentage
                    groupPersonalNetGdv
                    groupConvertNetGdv
                    groupNetGdvPercentage
                    salesRankingCommission
                    totalNetPrice
                    totalSPAPrice
                    groupNetPrice
                    groupSPAPrice
                }
            }
        }
    `,
    GENERATE_IK_SIGNATURE: gql`
        query {
            generateImageKitSignature {
                signature
                token
                expire
            }
        }
    `,
};

export default queries;